import DateInputAuth from "components/DateInputAuth";
import React from "react";

type Props = {
  errors: any;
  startContract: string;
  setStartContract: React.Dispatch<React.SetStateAction<string>>;
  endContract: string;
  setEndContract: React.Dispatch<React.SetStateAction<string>>;
};

const Dates: React.FC<Props> = ({
  errors,
  startContract,
  setStartContract,
  endContract,
  setEndContract,
}): JSX.Element => {
  return (
    <div className="flex flex-row">
      <div className="flex flex-col w-1/2 mr-1">
        <DateInputAuth
          label="Start date of the contract"
          value={startContract}
          onChange={(e) => setStartContract(e.target.value)}
          isHelp={errors?.startContract}
          helpText={errors?.startContract}
        />
      </div>
      <div className="flex flex-col w-1/2 ml-1">
        <DateInputAuth
          label="End date of the contract"
          value={endContract}
          onChange={(e) => setEndContract(e.target.value)}
          isHelp={errors?.endContract}
          helpText={errors?.endContract}
        />
      </div>
    </div>
  );
};

export default Dates;
